import api from './api';

export interface IcalUrlResponse {
  url: string;
}

export const kalenderService = {
  getIcalUrl: async (): Promise<{ url: string }> => {
    const response = await api.get('/kalender/ical-url');
    return response.data;
  },

  regenerateIcalToken: async (): Promise<void> => {
    await api.post('/kalender/ical-url/regenerate');
  },
};
